export default __webpack_public_path__ + "static/media/img-0721-estonia-full-face.a43b3729.png";